import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  ChartHopFieldCompact,
  ChartHopIntegrationConfig
} from '@dadohr/shared/domainTypes/integrations/charthop';
import { CF, FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toChartHopConfigDoc = generateToDocFn<ChartHopIntegrationConfig>();

const COLLECTION = FS.charthopIntegrationConfig;
const collection = () => store().collection(COLLECTION);
export const charthopConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toChartHopConfigDoc
);

export const useChartHopConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(charthopConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<ChartHopIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            orgSlug: '',
            apiToken: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeChartHopConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getChartHopFields = async (orgId: string) => {
  const result = await callFirebaseFunction<ChartHopFieldCompact[]>(
    CF.chartHop.getFields,
    { orgId }
  );
  return result;
};
